'use es6';

import { DragSource } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import DragTypes from 'simple-menus-core/enums/DragTypes';
const SET_DELAY_TIME = 500;
const UNSET_DELAY_TIME = 100;
const source = {
  canDrag(props) {
    return !props.readOnly;
  },
  beginDrag(props, monitor, component) {
    const sourceBoundingRect = findDOMNode(component).getBoundingClientRect();
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(true), {
        timeout: SET_DELAY_TIME
      });
    } else {
      props.setIsDragging(true);
    }
    return {
      id: props.id,
      parentId: props.parentId,
      menuId: props.menuId,
      label: props.label,
      width: sourceBoundingRect.width
    };
  },
  endDrag(props) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(false), {
        timeout: UNSET_DELAY_TIME
      });
    } else {
      props.setIsDragging(false);
    }
  },
  isDragging(props, monitor) {
    return props.id === monitor.getItem().id;
  }
};
export default function menuDragSource() {
  return Component => {
    return DragSource(DragTypes.ADVANCED_MENUS_MENU_NODE, source, (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    }))(Component);
  };
}